import React, { useEffect, useState } from "react";
import { Award, Trash2 } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { rupiah, num, fmtDate } from "@/lib/format";
import { Card, Loading, EmptyState, PageHeader, StatCard } from "@/components/common";

export default function Commissions() {
  const { branch, isOwner } = useAuth();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const load = () => {
    setLoading(true);
    api.get("/commissions", branch ? { branch_id: branch.id } : {}).then(setData).finally(() => setLoading(false));
  };
  useEffect(load, [branch]);
  const del = async (r) => {
    if (!window.confirm(`Hapus baris komisi ${r.arranger_name} (${rupiah(r.amount)})? Tidak bisa dibatalkan.`)) return;
    try { await api.del(`/commissions/${r.id}`); toast.success("Komisi dihapus"); load(); }
    catch (e) { toast.error(e.message); }
  };
  if (loading) return <Loading />;
  return (
    <>
      <PageHeader title="Komisi Perangkai" subtitle={data ? `${data.period.from} s/d ${data.period.to}` : ""} icon={Award} />
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
        <StatCard label="Total Komisi" value={rupiah(data?.total || 0)} tone="primary" />
        <StatCard label="Perangkai Aktif" value={num(data?.summary?.length || 0)} />
      </div>
      {!data?.summary?.length ? <EmptyState icon={Award} title="Belum ada komisi" message="Komisi tercatat saat order melewati tahap dirangkai." /> : (
        <>
          <Card className="overflow-hidden mb-6">
            <table className="w-full text-sm">
              <thead><tr className="text-left text-slate-400 border-b border-slate-100 bg-slate-50/50">
                <th className="py-3 px-4 font-medium">Perangkai</th><th className="py-3 px-4 font-medium text-right">Order</th>
                <th className="py-3 px-4 font-medium text-right">Item</th><th className="py-3 px-4 font-medium text-right">Komisi</th>
              </tr></thead>
              <tbody>
                {data.summary.map((r) => (
                  <tr key={r.arranger_id} className="border-b border-slate-50">
                    <td className="py-3 px-4 font-medium text-slate-800">{r.name}</td>
                    <td className="py-3 px-4 text-right">{r.orders}</td><td className="py-3 px-4 text-right">{num(r.items)}</td>
                    <td className="py-3 px-4 text-right font-semibold text-primary">{rupiah(r.amount)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Card>

          {isOwner && data?.rows?.length > 0 && (
            <Card className="overflow-hidden">
              <div className="px-4 py-3 border-b border-slate-100 font-semibold text-slate-700">Rincian Komisi (hapus per baris — Owner)</div>
              <table className="w-full text-sm">
                <thead><tr className="text-left text-slate-400 border-b border-slate-100 bg-slate-50/50">
                  <th className="py-3 px-4 font-medium">Tanggal</th><th className="py-3 px-4 font-medium">Perangkai</th>
                  <th className="py-3 px-4 font-medium">Order</th><th className="py-3 px-4 font-medium text-right">Item</th>
                  <th className="py-3 px-4 font-medium text-right">Komisi</th><th className="py-3 px-4 font-medium text-right">Aksi</th>
                </tr></thead>
                <tbody>
                  {data.rows.map((r) => (
                    <tr key={r.id} className="border-b border-slate-50" data-testid={`commission-row-${r.id}`}>
                      <td className="py-3 px-4 text-slate-400 text-xs">{fmtDate(r.created_at)}</td>
                      <td className="py-3 px-4 font-medium text-slate-800">{r.arranger_name}</td>
                      <td className="py-3 px-4 text-slate-500">{r.order_no || "-"}</td>
                      <td className="py-3 px-4 text-right">{num(r.qty)}</td>
                      <td className="py-3 px-4 text-right font-semibold text-primary">{rupiah(r.amount)}</td>
                      <td className="py-3 px-4 text-right"><button onClick={() => del(r)} className="w-8 h-8 rounded-lg hover:bg-rose-50 inline-flex items-center justify-center text-rose-500" data-testid={`delete-commission-${r.id}`} title="Hapus (Owner)"><Trash2 size={15} /></button></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Card>
          )}
        </>
      )}
    </>
  );
}
